module.exports = __webpack_public_path__ + "img/prev_arredo_disabled.ecaa4ba0.png";